import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

//create the store
export const store = new Vuex.Store({
  state: {
    APIToken: '',
    catagories: [],
    jewelry: [],
    showingModal: {
      active: false,
      name: ''
    },
    collection: '',
    currentFilter: 'catagory'
  },
  actions: {
    updateApiToken: ({ commit }, payload) => {
      commit('updateApiToken', payload)
    },
    updateCache: ({ commit }, payload) => {
      commit('loadCache', payload)
    },
    updateCatagories: ({ commit }, payload) => {
      commit('updateCatagories', payload)
    },
    updateJewelry: ({ commit }, payload) => {
      commit('updateJewelry', payload)
    },
    updateShowingModal: ({ commit }, payload) => {
      commit('updateShowingModal', payload)
    },
    updateCollection: ({ commit }, payload) => {
      commit('updateCollection', payload)
    },
    updateCurrentFilter: ({ commit }, payload) => {
      commit('updateCurrentFilter', payload)
    }
  },
  mutations: {
    updateApiToken: (state, payload) => {
      state.APIToken = payload
      localStorage.setItem('marsb-token', payload)
      persist()
    },
    loadCache: (state, payload) => {
      Object.assign(state, payload);
    },
    updateCatagories: (state, payload) => {
      state.catagories = payload
      persist()
    },
    updateJewelry: (state, payload) => {
      state.jewelry = payload
      persist()
    },
    updateCollection: (state, payload) => {
      state.collection = payload
      persist()
    },
    updateShowingModal: (state, payload) => {
      state.showingModal = payload
    },
    updateCurrentFilter: (state, payload) => {
      state.currentFilter = payload
    }
  },
  getters: {
   
  }
});

export const loadCache = () => {
  if (localStorage.getItem('marsb-state') != undefined) {
    let storageString = localStorage.getItem('marsb-state');
    let cache = JSON.parse(storageString);
    store.dispatch('updateCache', cache);
  }
};

export const purgeAll = () => {
  let payload = {
    
  }
  localStorage.clear();
  store.dispatch('purgeState', payload);
  window.location.href = "/"
};

function persist() {
  let storeState = JSON.stringify(store.state);
  localStorage.setItem('marsb-state', storeState);
}



// WEBPACK FOOTER //
// ./src/store/index.js